<template>
  <div id="app">
    <Popups/>
    <Notifications/>
    <router-view :key="$route.fullPath"/>
    <div id="loader" v-if="$store.state.mainStore.isLoading">
      <LoadingLogo/>
    </div>
    <image-zoomer v-if="!empty($store.state.mainStore.imageZoom)"/>
  </div>
</template>

<script>
import {Component, Vue, Watch} from 'vue-property-decorator';
import Popups from "./components/Popups.vue";
import Loading from "./components/Loading";
import LoadingLogo from "./components/LoadingLogo";
import {auth} from './services/Auth';

import {initializeApp} from "firebase/app";
import {onMessage, getToken, getMessaging} from "firebase/messaging";
import {DeviceUUID} from 'device-uuid';
import {api} from "@/services/Api";
import Notifications from "@/components/Notifications.vue";
import UserNotification from "@/entity/Notification";
import ImageZoomer from "@/components/ImageZoomer.vue";
import {liveManager} from "@/services/LiveManager";
import {notificationManager} from "@/services/NotificationManager";
import Tenant from "@/entity/Tenant";
import store from "@/store";

@Component({
  components: {ImageZoomer, Notifications, LoadingLogo, Loading, Popups}
})
export default class App extends Vue {

  publicPath = process.env.BASE_URL

  firebaseConfig = {
    apiKey: "AIzaSyDsEqmOFXyXhzpqoEkXPsfO0KN3HleOTj4",
    authDomain: "wiassur-ci.firebaseapp.com",
    projectId: "wiassur-ci",
    storageBucket: "wiassur-ci.appspot.com",
    messagingSenderId: "574176180579",
    appId: "1:574176180579:web:11629b32695c9cec77fb56",
    measurementId: "G-NXLWWKNNH6"
  };

  async beforeMount() {
    this.checkSource()
    this.checkAffiliation()
    try {
      this.requestPermission()
    } catch (e) {
    }
  }

  async registerDevice() {
    // console.log('register device')
    if (Notification.permission === 'granted') {
      const app = initializeApp(this.firebaseConfig);
      const messaging = getMessaging(app)

      // Apres un reset SW/cache (cas swVersion bump), Firebase reenregistre
      // firebase-messaging-sw.js automatiquement mais l'activation prend un
      // cycle event loop. getToken plante avec "no active Service Worker" si
      // on ne patiente pas. navigator.serviceWorker.ready resolve quand un SW
      // est active, ce qui garantit que getToken trouve son SW.
      try {
        if (navigator.serviceWorker) {
          await navigator.serviceWorker.ready
        }
      } catch (e) {
        console.warn('serviceWorker.ready failed, continuing anyway:', e)
      }

      getToken(messaging, {vapidKey: "BECYklXswYVf_6ehEOqPOzmNQ85XyKp4uM2EdIQ6NGFaFE9wJNfIKh11FfrFwspFHC8ejuB14MX7bq2aiV0_iQg"}).then(async (currentToken) => {
        const localToken = localStorage.getItem('fcm')
        // console.log(currentToken)
        // console.log('App client token', currentToken)
        // console.log('App local token', localToken)
        if (currentToken && currentToken !== localToken) {
          localStorage.setItem('fcm', currentToken)
          // console.log('App client token', currentToken)
          var uuid = new DeviceUUID().get();
          var parsed = new DeviceUUID().parse();
          const data = {
            id: uuid,
            token: currentToken,
            brand: this.$device.brand,
            model: this.$device.model,
            name: parsed.platform,
            type: this.$device.type,
            isEmulator: false,
            isSecured: false,
          };

          if (auth.hasRole('ROLE_MANAGER')) {
            const res = await api.post(api.auth, 'user/register/device', data)
            if (!res || !res.data) {
              localStorage.removeItem('fcm')
            }
          } else if (auth.hasRole('ROLE_PARTNER')) {
            const res = await api.post(api.auth, 'partner/api/register/device', data)
            if (!res || !res.data) {
              localStorage.removeItem('fcm')
            }
          }
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      })
      onMessage(messaging, (payload) => {
        // BroadcastChannel NE renvoie PAS le message a l'onglet emetteur,
        // uniquement aux autres tabs/workers. On doit donc appeler handleMessage
        // directement pour l'onglet courant, sinon le watcher store du chat
        // ne se declenche jamais ici.
        notificationManager.channel.postMessage(payload);
        notificationManager.handleMessage(payload);
      });
    }
  }

  // get fullPath() {
  //   return this.$route.fullPath
  // }
  //
  // @Watch('fullPath', { immediate: true })
  // onRouteChange(newPath) {
  //   if (auth.getCurrentUser() && !this.$store.state.mainStore.currentTenant) {
  //     console.log('utilisateur et non tenant')
  //     if(this.$route.name !== 'tenant-selector'){
  //       this.$router.replace({name: 'tenant-selector'})
  //     }
  //     return
  //   }
  // }

  // Bump this string a chaque deploy qui casse la compat runtime (state store,
  // structure notif, nouveau field reactif, SW change, etc.). Chaque user qui
  // ouvre l'admin apres deploy se voit desinscrire son SW, vider le cache et
  // recharger automatiquement. Aucune manipulation a faire de leur cote.
  swVersion = '4'

  requestPermission() {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
      }
    })
  }

  /**
   * Detecte un nouveau deploy via swVersion. Si mismatch :
   *   - desinscrit TOUS les service workers (firebase-messaging-sw, autres)
   *   - vide la CacheStorage API (assets mis en cache par le SW)
   *   - hard reload pour que le navigateur fetch le nouveau bundle
   *
   * Ordre important : on stocke la nouvelle version AVANT de reload pour
   * eviter une boucle infinie. La 1re visite (stored vide) se contente
   * d'enregistrer la version sans reload.
   */
  async updateWorker() {
    const currentVersion = localStorage.getItem('swVersion')
    if (currentVersion === this.swVersion) return

    const isFirstVisit = !currentVersion
    localStorage.setItem('swVersion', this.swVersion)
    if (isFirstVisit) return

    try {
      const regs = navigator.serviceWorker ? await navigator.serviceWorker.getRegistrations() : []
      await Promise.all(regs.map(r => r.unregister()))
      if ('caches' in window) {
        const keys = await caches.keys()
        await Promise.all(keys.map(k => caches.delete(k)))
      }
    } catch (e) {
      console.warn('Cleanup au changement de swVersion :', e)
    }
    window.location.reload()
  }

  async mounted() {
    // await : si updateWorker declenche un reload (bump swVersion), la page
    // repart a zero et le reste de mounted ne s'execute pas. Sans await, on
    // lancerait registerDevice en parallele d'un unregister SW, provoquant
    // "no active Service Worker" sur getToken.
    await this.updateWorker()
    this.detectZone()
    this.registerDevice()
    this.$store.dispatch('masterStore/syncMaster')

    if (navigator.serviceWorker) {
      this.$addListener(navigator.serviceWorker, 'message', (event) => {
        if (event.data?.action === 'NOTIFICATION') {
          const payload = event.data.payload;
          // Cas legacy : alerte audio SMS_ERROR
          if (payload.type === 'SMS_ERROR') {
            const audio = new Audio(process.env.BASE_URL + 'notification.wav');
            new UserNotification(payload);
            audio.play();
          }
          // Forward tous les autres pushes (MESSAGE_RECEIVED, etc.) au handler
          // standard : c'est ce qui commit au store pour declencher les watchers
          // de Conversation.vue et RiskStatesPanel.vue.
          notificationManager.handleMessage(payload);
        }
      });
    }
  }

  checkSource() {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    if (urlParams.has('source')) {
      const source = urlParams.get('source')
      if (source) {
        this.$store.state.source = source
      }
    }
  }

  checkAffiliation() {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    if (urlParams.has('affiliation')) {
      const affiliation = urlParams.get('affiliation')
      if (affiliation) {
        this.$store.state.affiliation = affiliation
      }
    }
  }

  detectZone() {
    const params = new URLSearchParams(window.location.search)
    const zone = params.get("zone")
    if (zone) {
      let tenant = null
      try {
        tenant = this.$store.state.tenants.find(t =>
            t.code.toLowerCase() === zone.toLowerCase()
        )
      } catch (e) {
      }
      if (!tenant) {
        tenant = new Tenant()
        tenant.code = zone
        tenant.label = zone
      }
      localStorage.setItem('currentTenant', JSON.stringify(tenant))
      const query = {...this.$route.query}
      delete query.zone
      this.$router.replace({path: window.location.pathname, query})
      if (this.$store.state.currentTenant?.code !== tenant.code) {
        this.$store.state.currentTenant = tenant
        //window.location.reload()
      }
    }
    this.$store.commit('updateCurrency')
  }

  deliveryTimeout = null
  loadDeliveryQueries() {
    if (auth.hasRole('ROLE_MANAGER')) {
      this.deliveryTimeout = setTimeout(() => {
        this.$store.getters.deliveries()
        this.loadDeliveryQueries()
      }, 60000)
    }
  }
}
</script>
<style>
:root {
  --primary: #3ddad7;
  --secondary: #f8069c;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;

}

#loader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

#nav {
  padding: 30px;
}

a {
  /*color: inherit!important;*/
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a i {
  /*color:gray!important*/
}

#nav a.router-link-exact-active {
  color: #42b983;
}


#app {
  flex: 1;
  display: flex;
}

.input-group-append .input-group-text {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.input-group-prepend .input-group-text {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.title {
  font-size: 2em;
  font-weight: bolder;
  color: var(--secondary);
  text-align: left;
  align-items: center;
  padding: 20px 0;
}

.title i {
  color: var(--secondary);
}

i,
i:after,
i:before {
  /*color: inherit !important;*/
}

.signature {
  font-size: .9em;
  font-style: italic;
  font-weight: bolder;
}

button.close {
  border: none;
  background: transparent;
}
</style>
